import { render, staticRenderFns } from "./CaseReviewFindingsView.vue?vue&type=template&id=56edbf7c&"
import script from "./CaseReviewFindingsView.vue?vue&type=script&lang=js&"
export * from "./CaseReviewFindingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports